export default "__VITE_ASSET__e0484e43__"